/* 🤖 this file was generated by script */
export const wiconMinus = {
  name: 'minus',
  data: `<svg viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 12h14"/></svg>`,
};
